/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FormResponse } from '../models/FormResponse';
import type { FormResponseAnswer } from '../models/FormResponseAnswer';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class FormResponseService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get a single form response by its guid.
     * @param orgGuid
     * @param formDefinitionGuid The form's guid.
     * @param responseGuid The response's guid.
     * @returns FormResponse OK
     * @throws ApiError
     */
    public getFormResponse(
        orgGuid: string,
        formDefinitionGuid: string,
        responseGuid: string,
    ): CancelablePromise<FormResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/mwforms/{orgGuid}/{formDefinitionGuid}/{responseGuid}/GetResponse',
            path: {
                'orgGuid': orgGuid,
                'formDefinitionGuid': formDefinitionGuid,
                'responseGuid': responseGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get all the recently updated answers for a form response.
     * @param orgGuid
     * @param formDefinitionGuid The form's guid.
     * @param responseGuid The response's guid.
     * @returns FormResponseAnswer OK
     * @throws ApiError
     */
    public getFormResponseRecentAnswers(
        orgGuid: string,
        formDefinitionGuid: string,
        responseGuid: string,
    ): CancelablePromise<Array<FormResponseAnswer>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/mwforms/{orgGuid}/{formDefinitionGuid}/{responseGuid}/GetFormResponseRecentAnswers',
            path: {
                'orgGuid': orgGuid,
                'formDefinitionGuid': formDefinitionGuid,
                'responseGuid': responseGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Delete a form response by its Guid.
     * @param orgGuid
     * @param formDefinitionGuid
     * @param responseGuid The response's guid.
     * @returns FormResponse OK
     * @throws ApiError
     */
    public deleteFormResponse(
        orgGuid: string,
        formDefinitionGuid: string,
        responseGuid: string,
    ): CancelablePromise<FormResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/mwforms/{orgGuid}/{formDefinitionGuid}/{responseGuid}/DeleteFormResponse',
            path: {
                'orgGuid': orgGuid,
                'formDefinitionGuid': formDefinitionGuid,
                'responseGuid': responseGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
